import { configureStore } from '@reduxjs/toolkit'
import LanguageReducer from "./languageSlice"

export default configureStore({
  reducer:{
      languageReducer: LanguageReducer
  },
})